export const ACCOUNTS = 'accounts';
export const ACCOUNTS_GET_ALL = 'accounts/all';
export const ACCOUNT_ADD_NEW = 'account/new';
